module.exports = __webpack_public_path__ + "img/close.629e287d.svg";